import { ApprovalStatus } from '../../main/components/Preset/models';

const EditButton = ({ id, username, label }: { id: number; username: string; label: string }) => {
  const handleSubmit = async () => {
    await editPreset();

    await notifyStatusChange();

    window.location.href = `/${id}`;
  };

  const editPreset = async () => {
    try {
      await fetch(
        `https://prod-15.eastus.logic.azure.com:443/workflows/935c0d0a0c654359b40a954cc118770b/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=BzAcr3yCy2ijN2IrSloKghn27qZenIWePKTcWkyZwzA`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: id,
            newStatus: ApprovalStatus.PRIVATE,
          }),
        }
      );
    } catch (error) {
      console.error('Error editing preset:', error);
    }
  };

  const notifyStatusChange = async () => {
    try {
      const response = await fetch(
        'https://prod-63.eastus.logic.azure.com:443/workflows/fb031a87ddcc4fee89a2a78a306662d9/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=sqmR4K3nazu8K5dwq5gj4dYQ9nVGJUp-BRMkurGx6w0',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: id,
            email: username,
            label: label,
            status: 'draft',
          }),
        }
      );
    } catch (error) {
      console.error('Error notifying status change:', error);
    }
  };

  return (
    <div>
      <button onClick={handleSubmit} style={buttonStyles}>
        Edit
      </button>
    </div>
  );
};

// Define styles for the button
const buttonStyles = {
  height: '5.6vh',
  width: '24vh',
  fontSize: '1.6vh',
  fontWeight: '700',
  color: '#00AB9B',
  backgroundColor: 'transparent',
  border: '2px solid #00AB9B',
  borderRadius: '1.6vh',
  cursor: 'pointer',
  transition: 'background-color 0.3s, transform 0.2s',
  outline: 'none',
};

export default EditButton;
